<template>
  <div class="__user_button" @click="open()">
    <font-awesome-icon :icon="['fas', 'user']" />
  </div>
</template>

<script>
export default {
  name: "UserButton",
  methods: {
    open() {
      this.$emit("open");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../theme.scss";

.__user_button {
  width: 56px;
  height: 56px;
  background-color: $primary;
  line-height: 56px;
  text-align: center;
  font-size: 26px;
  font-weight: 500;
  border-radius: 100%;
  color: white;
  cursor: pointer;

  &:hover {
    color: $secondary;
  }
}
</style>
